import { render, staticRenderFns } from "./batchReceivableChange.vue?vue&type=template&id=cd67421e&scoped=true"
import script from "./batchReceivableChange.vue?vue&type=script&lang=js"
export * from "./batchReceivableChange.vue?vue&type=script&lang=js"
import style0 from "./batchReceivableChange.vue?vue&type=style&index=0&id=cd67421e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd67421e",
  null
  
)

export default component.exports